import script from "./popupCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./popupCopy.vue?vue&type=script&setup=true&lang=js"

import "./popupCopy.vue?vue&type=style&index=0&id=37c60678&lang=scss"

const __exports__ = script;

export default __exports__